import {PrimerComponentLogoSuiteSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentLogoSuite'
import {PrimerComponentTestimonialSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentTestimonial'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {FormSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/form'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'

export const TemplateContactSalesSchema = buildEntrySchemaFor('templateContactSalesForm', {
  fields: z.lazy(() =>
    z.object({
      body: safeOptional(RichTextSchema),
      headline: z.string(),
      label: z.string().optional(),
      highlight: safeOptional(PrimerComponentLogoSuiteSchema.or(PrimerComponentTestimonialSchema)),
      branding: z.union([z.literal('Platform'), z.literal('AI'), z.literal('Security')]).optional(),
      redirect: z.string().optional(),
      form: safeOptional(FormSchema),
      formRequirementMessage: safeOptional(RichTextSchema),
    }),
  ),
})

export type TemplateContactSalesForm = z.infer<typeof TemplateContactSalesSchema>
